import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  zIndex: 999999999,
};

export default function CropperModalCom(props: any) {
  const handleClose = (e: any) => {
    e.preventDefault();
    props.setIsCrop(false);
  };
  return (
    <div>
      <Modal
        open={props.open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        sx={{ zIndex: "99999999" }}
      >
        <Box sx={{ ...style, width: 400 }}>{props.children}</Box>
      </Modal>
    </div>
  );
}
